import { actions as authActions } from 'features/Auth';

import { initialState } from './initial';
import { actionTypes } from './actions';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case authActions.actionTypes.LOGOUT:
      return { ...initialState };

    case actionTypes.ACTION_PROCESSING:
      return { ...state, actionProcessing: action.payload };

    case actionTypes.SET_STATUS_DATA:
      return { ...state, ...(action.payload ?? {}), isStatusLoaded: true };

    case actionTypes.SET_STATUS:
      return { ...state, status: action.payload };

    case actionTypes.SET_CURRENT_QUESTION:
      return { ...state, currentQuestionId: action.payload };

    case actionTypes.OPEN_MODAL:
      return { ...state, isModalOpen: true };

    case actionTypes.CLOSE_MODAL:
      return { ...state, isModalOpen: false };

    default:
      return state;
  }
};
